/* eslint-disable max-params */
import type { Validator } from 'prop-types';

export const tupleValidator = (tupleShape: Validator<unknown>[]): Validator<unknown> => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
  const func: Validator<unknown> = (value, index, ...rest) =>
    tupleShape[index as unknown as number](value, index, ...rest);
  return func;
};
